import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./allevents.css";
import EventsDesign from '../../atrimages/onineimg/eventschudle logo.webp';
import ClubPic from "../../atrimages/onineimg/club event img.jpg";

export default function Events() {
  return (
    <>
      <div className="EventsWrapper">
        <img
          src={EventsDesign}
          alt="events_design_logo"
          className="eventLogo"
        />

        {/* <button className="event-btn">ON GOING EVENTS</button>
        <button className="event-btn">Download Rule Book</button> */}
        <h1>ALl Events Info</h1>
        <div className="erow">
          <div className="ecol c1">
            <NavLink to="club">
              <img
                src={ClubPic}
                alt="clubEvents"
              />
              <h1>Club Events</h1>
            </NavLink>
            {/* mY Text Info */}
          </div>
          <div className="ecol c2">
            <NavLink to="committe">
              <img
                src="https://wallpaperaccess.com/full/1490326.jpg"
                alt="committeEvents"
              />
              <h1>committe Events</h1>
            </NavLink>
            {/* mY Text Info */}
          </div>
        </div>
      </div>

      <Outlet />
    </>
  );
}
